import { PromptTopic } from '../types';

export const mockPromptTopics: PromptTopic[] = [
  { id: 'topic_1', name: '资产管理平台', prompt_count: 10 },
  { id: 'topic_2', name: '最佳交易工具', prompt_count: 12 },
  { id: 'topic_3', name: '投资App评测', prompt_count: 8 },
  { id: 'topic_4', name: '在线交易平台', prompt_count: 11 },
  { id: 'topic_5', name: '股票券商服务', prompt_count: 9 },
];

export const mockPromptsData = {
  total: 50,
  page: 1,
  limit: 20,
  topics: mockPromptTopics,
  data: [
    {
      id: 'prompt_1',
      title: '哪里可以开始在线管理我的资产？',
      description: '追踪 AI 对资产管理和个人理财平台的初学者推荐情况。',
      created_at: '2026-05-27T10:00:00Z',
      used_count: 42,
      visibility: 18,
      sentiment: 71,
      position: 3.2,
      mentions: 3,
      volume: 2400,
      tags: ['资产管理', '入门'],
      location: 'HK',
      sov: 4,
      web_search: true,
      topic: '资产管理平台',
    },
    {
      id: 'prompt_2',
      title: '500美元以内最好的交易工具有哪些？',
      description: '对比经济实惠的图表、券商、扫描仪、交易日志和行情数据工具。',
      created_at: '2026-05-27T09:30:00Z',
      used_count: 38,
      visibility: 12,
      sentiment: 64,
      position: 5.1,
      mentions: 2,
      volume: 1900,
      tags: ['工具', '预算'],
      location: 'HK',
      sov: 2,
      web_search: true,
      topic: '最佳交易工具',
    },
    {
      id: 'prompt_3',
      title: '哪家在线券商最适合活跃交易者？',
      description: '对券商品牌和活跃交易工作流的仓位质量进行基准测试。',
      created_at: '2026-05-26T17:20:00Z',
      used_count: 31,
      visibility: 24,
      sentiment: 58,
      position: 6.8,
      mentions: 4,
      volume: 3200,
      tags: ['券商'],
      location: 'US',
      sov: 5,
      web_search: true,
      topic: '在线交易平台',
    },
    {
      id: 'prompt_4',
      title: '对新手投资者来说哪些App最安全？',
      description: '衡量 AI 推荐应用时对信任、安全和监管语言的表达。',
      created_at: '2026-05-26T12:45:00Z',
      used_count: 27,
      visibility: 7,
      sentiment: 77,
      position: 4.3,
      mentions: 1,
      volume: 1600,
      tags: ['信任', 'App'],
      location: 'UK',
      sov: 1,
      web_search: false,
      topic: '投资App评测',
    },
    {
      id: 'prompt_5',
      title: '纸上交易最好的平台是哪个？',
      description: '探究 AI 助手是否会引用模拟交易工具和券商练习账户。',
      created_at: '2026-05-25T11:20:00Z',
      used_count: 24,
      visibility: 31,
      sentiment: 61,
      position: 5.4,
      mentions: 5,
      volume: 1300,
      tags: ['模拟交易'],
      location: 'US',
      sov: 6,
      web_search: true,
      topic: '股票券商服务',
    },
    {
      id: 'prompt_6',
      title: '如何选择适合自己的股票分析软件？',
      description: '评估技术指标、基本面分析和 AI 选股功能的覆盖情况。',
      created_at: '2026-05-24T14:10:00Z',
      used_count: 19,
      visibility: 9,
      sentiment: 55,
      position: 7.2,
      mentions: 1,
      volume: 980,
      tags: ['分析', '软件'],
      location: 'CN',
      sov: 1,
      web_search: true,
      topic: '最佳交易工具',
    },
    {
      id: 'prompt_7',
      title: '加密货币交易所怎么选？',
      description: '考察 AI 在推荐交易所时对手续费、安全性、流动性的权重。',
      created_at: '2026-05-24T09:00:00Z',
      used_count: 35,
      visibility: 6,
      sentiment: 49,
      position: null,
      mentions: 0,
      volume: 4100,
      tags: ['加密货币', '交易所'],
      location: 'SG',
      sov: 0,
      web_search: true,
      topic: '在线交易平台',
    },
    {
      id: 'prompt_8',
      title: '哪个平台提供最好的股票筛选器？',
      description: '测量各 AI 模型对量化选股和条件筛选工具的引用频率。',
      created_at: '2026-05-23T16:45:00Z',
      used_count: 22,
      visibility: 41,
      sentiment: 68,
      position: 2.9,
      mentions: 7,
      volume: 870,
      tags: ['筛选器', '量化'],
      location: 'US',
      sov: 8,
      web_search: false,
      topic: '最佳交易工具',
    },
    {
      id: 'prompt_9',
      title: '基金定投哪个平台手续费最低？',
      description: '追踪 AI 对低费率指数基金定投平台的推荐偏好。',
      created_at: '2026-05-23T10:30:00Z',
      used_count: 18,
      visibility: 0,
      sentiment: null,
      position: null,
      mentions: 0,
      volume: 2150,
      tags: ['基金', '定投'],
      location: 'CN',
      sov: 0,
      web_search: false,
      topic: '资产管理平台',
    },
    {
      id: 'prompt_10',
      title: '外汇交易平台如何对比优劣？',
      description: '评估点差、杠杆、监管和用户体验在 AI 推荐中的权重。',
      created_at: '2026-05-22T13:20:00Z',
      used_count: 16,
      visibility: 3,
      sentiment: 52,
      position: 8.1,
      mentions: 1,
      volume: 1750,
      tags: ['外汇', 'FX'],
      location: 'UK',
      sov: 1,
      web_search: true,
      topic: '在线交易平台',
    },
  ],
};
